var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyComments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 45,
    viewBox: "0 0 48 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 0V33H17.1328L6 44.1328V33H0V0H48ZM45 3H3V30H9V36.8672L15.8672 30H45V3ZM30 18H27V12H33V18C33 18.4219 32.9219 18.8125 32.7656 19.1719C32.6094 19.5312 32.3906 19.8516 32.1094 20.1328C31.8438 20.3984 31.5312 20.6094 31.1719 20.7656C30.8125 20.9219 30.4219 21 30 21V18ZM18 18H15V12H21V18C21 18.4219 20.9219 18.8125 20.7656 19.1719C20.6094 19.5312 20.3906 19.8516 20.1094 20.1328C19.8438 20.3984 19.5312 20.6094 19.1719 20.7656C18.8125 20.9219 18.4219 21 18 21V18Z",
    fill: "#878787"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyComments);
export default __webpack_public_path__ + "static/media/empty-comments.af0ac65e59b41f5132e53c58f04bded5.svg";
export { ForwardRef as ReactComponent };